import Component from '@bythepixel/component-loader';
import { clickIsInElement } from '@Utility';
import { EVENT_NAMES } from './events';
import { Templates } from './config';

export default class SnackbarController extends Component {
  static selector = '[data-comp-snackbar-controller]';

  REMOVAL_DELAY = 5000;

  activeSnackbar = null;
  activeTimeout = null;

  constructor(containerEl) {
    super(containerEl);

    this.mount();
  }

  attachListeners() {
    window.addEventListener(EVENT_NAMES.ADD, (e) => {
      if (this.activeSnackbar) {
        clearTimeout(this.activeTimeout);
        this.removeActiveSnackbar();
      }

      const options = e.detail;
      const SnackbarClass = Templates.get(options.template);
      const Snackbar = new SnackbarClass(options);

      if (Snackbar.isDismissable()) {
        Snackbar.buttonContainer.addEventListener('click', () => {
          this.removeActiveSnackbar();
        });
      }

      this.showSnackbar(Snackbar);
    });

    window.addEventListener('click', (e) => {
      if (!this.activeSnackbar) return;

      const clickInsideContainer = clickIsInElement(e, this.$container);

      if (this.activeSnackbar?.isDismissable() || clickInsideContainer) return;

      clearTimeout(this.activeTimeout);
      this.removeActiveSnackbar();
    });
  }

  showSnackbar(snackbar) {
    this.activeSnackbar = snackbar;
    snackbar.addTo(this.$container);

    // Adding the class to animate the snackbar immediately after appending
    // it to the main container prevents the animation. Adding a short delay
    // fixes this
    setTimeout(() => {
      snackbar.show();
    }, 50);

    if (snackbar.isDismissable()) return;

    this.activeTimeout = setTimeout(() => {
      this.removeActiveSnackbar();
    }, this.REMOVAL_DELAY);
  }

  removeActiveSnackbar() {
    this.activeSnackbar.dismount().then((container) => container.remove());
  }

  mount() {
    this.attachListeners();
  }
}
